var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardLinkSupportQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.0392 3.9704C30.4541 0.399148 25.2993 0 19 0C12.6927 0 7.53007 0.40375 3.9465 3.98465C0.363448 7.56406 0 12.7184 0 19.0184C0 25.3195 0.363448 30.4754 3.94798 34.0561C7.53133 37.6375 12.6934 38 19 38C25.3066 38 30.4678 37.6375 34.0511 34.0561C37.6354 30.4748 37.9999 25.3195 37.9999 19.0184C37.9999 12.7103 37.6315 7.55041 34.0392 3.9704Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50098 19C9.50098 14.5217 9.50098 12.2825 10.8922 10.8912C12.2835 9.5 14.5226 9.5 19.001 9.5C23.4793 9.5 25.7185 9.5 27.1098 10.8912C28.501 12.2825 28.501 14.5217 28.501 19C28.501 23.4783 28.501 25.7175 27.1098 27.1088C25.7185 28.5 23.4793 28.5 19.001 28.5C14.5226 28.5 12.2835 28.5 10.8922 27.1088C9.50098 25.7175 9.50098 23.4783 9.50098 19Z",
    stroke: "#00453C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H24",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H15",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19H15",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H15",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H24",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H24",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLinkSupportQuestion);
export default __webpack_public_path__ + "static/media/card_link_support_question.bc5e4d65602e2e9607e77bfc87fca528.svg";
export { ForwardRef as ReactComponent };